/**
 * UpgradeScreen — exibido quando o trial de 7 dias expirou.
 * Bloqueia todo acesso e mostra tela de planos para upgrade.
 */
import React from 'react';
import { LogOut } from 'lucide-react';
import Planos from '../Planos';
import type { PlanoSelecionado } from '../Planos';

interface UpgradeScreenProps {
  empresaNome?: string;
  planoInfo?: any;
  onUpgrade?: () => void;
  onContratarPlano?: (plano: PlanoSelecionado) => void;
  onLogout?: () => void;
}

const UpgradeScreen: React.FC<UpgradeScreenProps> = ({ empresaNome, planoInfo, onContratarPlano, onLogout }) => {
  return (
    <div className="fixed inset-0 z-[9999] overflow-y-auto bg-white">
      {/* Logout button */}
      {onLogout && (
        <button
          onClick={onLogout}
          className="fixed top-4 right-4 z-[10000] flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-gray-600 bg-white border border-gray-200 hover:bg-gray-50 hover:text-gray-900 transition-colors shadow-sm"
        >
          <LogOut className="w-4 h-4" />
          Sair
        </button>
      )}
      <Planos
        planoInfo={planoInfo}
        empresaNome={empresaNome}
        modo="pagina"
        onContratarPlano={onContratarPlano}
      />
    </div>
  );
};

export default UpgradeScreen;
